export const baseUrl = '/manifests'
